export default __webpack_public_path__ + "static/media/cafeshow_throo03.7b08aa29.png";